/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { isMacPlatform } from '../../agent/keyboard';

export const formatSettingsShortcut = () => (isMacPlatform() ? '⌘,' : 'Ctrl+,');
